import { getCSRFToken, fetchCSRFToken } from "./csrf";

const BASE_URL = "/api/_allauth/browser/v1";

async function request(method, endpoint, data = null) {
  let csrfToken = getCSRFToken();

  if (!csrfToken) {
    await fetchCSRFToken();
    csrfToken = getCSRFToken();
  }

  const headers = {
    "Content-Type": "application/json",
    "X-CSRFToken": csrfToken,
  };

  const options = {
    method,
    headers,
    credentials: "include",
  };

  if (data) options.body = JSON.stringify(data);

  const response = await fetch(`${BASE_URL}${endpoint}`, options);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.errors?.[0]?.message || "Something went wrong.");
  }

  return response.json();
}

export async function signUp({ email, username, password }) {
  return request("POST", "/auth/signup", { email, username, password });
}
export async function signIn({ email, password }) {
  return request("POST", "/auth/login", { email, password });
}

export async function verifyEmail({ key }) {
  try {
    let csrfToken = getCSRFToken();
    if (!csrfToken) {
      await fetchCSRFToken();
      csrfToken = getCSRFToken();
    }

    const response = await fetch(`${BASE_URL}/auth/email/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      credentials: "include",
      body: JSON.stringify({ key }),
    });
    const data = await response.json().catch(() => ({}));
    return { status: response.status, data };
  } catch (error) {
    return { status: 0, data: {}, message: error.message };
  }
}
